/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ForecastState
 */
export interface ForecastState {
  /**
   *
   * @type {string}
   * @memberof ForecastState
   */
  cageId: string;
  /**
   *
   * @type {boolean}
   * @memberof ForecastState
   */
  useDateAsStarvationTrigger?: boolean;
  /**
   *
   * @type {string}
   * @memberof ForecastState
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  openCount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  openWeight: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  openBiomass: number;
  /**
   *
   * @type {string}
   * @memberof ForecastState
   */
  openSpecies: ForecastStateOpenSpeciesEnum | null;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  availableCount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  availableWeight: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  availableBiomass: number;
  /**
   *
   * @type {string}
   * @memberof ForecastState
   */
  availableSpecies: ForecastStateAvailableSpeciesEnum | null;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  closingCount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  closingWeight: number;
  /**
   *
   * @type {number}
   * @memberof ForecastState
   */
  closingBiomass: number;
  /**
   *
   * @type {string}
   * @memberof ForecastState
   */
  closingSpecies: ForecastStateClosingSpeciesEnum | null;
}

export const ForecastStateOpenSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type ForecastStateOpenSpeciesEnum =
  (typeof ForecastStateOpenSpeciesEnum)[keyof typeof ForecastStateOpenSpeciesEnum];
export const ForecastStateAvailableSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type ForecastStateAvailableSpeciesEnum =
  (typeof ForecastStateAvailableSpeciesEnum)[keyof typeof ForecastStateAvailableSpeciesEnum];
export const ForecastStateClosingSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type ForecastStateClosingSpeciesEnum =
  (typeof ForecastStateClosingSpeciesEnum)[keyof typeof ForecastStateClosingSpeciesEnum];
